import type { MediaItem } from "@/types/media";

export const MOVIE_REGIONS = ["全部", "中国大陆", "中国香港", "中国台湾", "美国", "英国", "挪威", "韩国", "日本"];

export const MOVIE_GENRES = ["全部", "科幻", "悬疑", "犯罪", "剧情", "动作", "冒险", "爱情", "战争", "家庭"];

export const YEAR_OPTIONS = ["全部", "2026", "2025", "2024", "2023"];

export const TV_GENRES = ["全部", "悬疑", "犯罪", "古装", "都市", "刑侦", "科幻", "情感", "谍战", "年代", "惊悚"];

export const mediaList: MediaItem[] = [
  {
    id: "m-001",
    type: "movie",
    title: "星际回响",
    poster:
      "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20space%20scene%20with%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20planet%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=vast%20cosmic%20space%20scene%20with%20glowing%20nebula%20and%20distant%20planet%2C%20dark%20cinematic%20mood%2C%20deep%20blue%20and%20amber%20tones%2C%20no%20text%2C%20highly%20detailed&width=1600&height=900&seq=mogu-bd-01&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["科幻", "剧情"],
    rating: 8.9,
    duration: "138分钟",
    episodeCount: 0,
    director: "陆沉",
    cast: ["程亦", "苏婉", "林深", "周宁"],
    releaseDate: "2026-07-18",
    summary: "一支深空探测队在返航途中接收到来自未知星域的神秘信号，真相远超所有人的想象。",
    synopsis:
      "2049 年，人类第一艘载人深空探测器“回响号”在完成对柯伊伯带外侧的勘测后踏上归途。航行途中，通讯官苏婉捕捉到一段规律性极强的低频信号，它似乎来自一个早已被判定为死寂的星系。船长程亦决定偏离航线追踪信号源，却让全体船员陷入一场关于时间、记忆与文明存续的抉择。当真相一层层揭开，他们才意识到，回响的不只是宇宙，更是人类自己。",
    hot: 98,
  },
  {
    id: "m-002",
    type: "movie",
    title: "雾城迷案",
    poster:
      "https://readdy.ai/api/search-image?query=noir%20crime%20mystery%20scene%20of%20a%20misty%20city%20street%20at%20night%20with%20a%20silhouette%20detective%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-02&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.4,
    duration: "124分钟",
    episodeCount: 0,
    director: "裴云",
    cast: ["秦川", "许薇", "孟舟"],
    releaseDate: "2026-06-05",
    summary: "连环失踪案背后藏着二十年前的旧账，刑警与被遗忘的证人共同走进迷雾深处。",
    synopsis:
      "连续三起手法一致的失踪案让江城市人心惶惶。刑警队长秦川在调查中发现，受害人都与二十年前的一场工厂事故有关。随着线索逐渐收拢，一位被所有人遗忘的目击者浮出水面。雾气笼罩的城市里，真相与谎言只隔着一层薄雾，而秦川要做的，是在天亮之前把它吹散。",
    hot: 95,
  },
  {
    id: "m-003",
    type: "movie",
    title: "深海余光",
    poster:
      "https://readdy.ai/api/search-image?query=deep%20ocean%20adventure%20scene%20with%20sunlight%20rays%20piercing%20dark%20blue%20water%20and%20a%20diver%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-03&orientation=portrait",
    backdrop: "",
    year: 2025,
    region: "中国大陆",
    genres: ["剧情", "冒险"],
    rating: 8.1,
    duration: "132分钟",
    episodeCount: 0,
    director: "海岩川",
    cast: ["周芷", "陈默", "吴岸"],
    releaseDate: "2025-12-20",
    summary: "一名海洋生物学家潜入马里亚纳海沟，寻找失踪的科考船与失落的记忆。",
    synopsis:
      "海洋生物学家周芷接到一封来自已故导师的信件，信中只留下一组坐标。她组建小队前往马里亚纳海沟，那里沉睡着失踪三年的科考船“余光号”。在万米黑暗与高压之下，她们不仅找到残骸，也找回了被刻意掩埋的科研真相。",
    hot: 88,
  },
  {
    id: "m-004",
    type: "movie",
    title: "荒原之歌",
    poster:
      "https://readdy.ai/api/search-image?query=western%20drama%20scene%20of%20a%20lone%20rider%20crossing%20a%20golden%20desert%20plain%20at%20sunset%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-04&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "美国",
    genres: ["剧情", "冒险"],
    rating: 8.6,
    duration: "146分钟",
    episodeCount: 0,
    director: "Daniel Reed",
    cast: ["Ethan Cole", "Mia Turner", "Noah Blake"],
    releaseDate: "2026-03-14",
    summary: "失去一切的流浪者穿越荒原，只为把一封信送到早已消失的故乡。",
    synopsis:
      "在内战结束后的西部荒原，沉默的流浪者 Ethan 背负着一个承诺：把一封家书送到千里之外的小镇。沿途他遇见了偷马贼、失落的乐手和一位执意同行的女医生。荒原辽阔，歌声苍凉，而每一次选择都在重新定义“回家”的意义。",
    hot: 90,
  },
  {
    id: "m-005",
    type: "movie",
    title: "霓虹追凶",
    poster:
      "https://readdy.ai/api/search-image?query=neon%20lit%20hong%20kong%20street%20at%20night%20with%20action%20silhouette%20and%20rain%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-05&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "中国香港",
    genres: ["动作", "犯罪"],
    rating: 7.9,
    duration: "118分钟",
    episodeCount: 0,
    director: "关子谦",
    cast: ["郭天", "李芷", "麦浩"],
    releaseDate: "2026-05-22",
    summary: "卧底警察与传奇劫匪在霓虹灯下的最后一场追逐，没有赢家。",
    synopsis:
      "卧底七年的警察郭天终于接近犯罪集团核心，却在行动前一晚身份暴露。传奇劫匪“霓虹”带着他穿过整座城市的雨夜，只为让他亲眼见证一场交易的真相。霓虹闪烁，警笛渐近，这场追逐的终点，是两代人对“正义”不同的注解。",
    hot: 86,
  },
  {
    id: "m-006",
    type: "movie",
    title: "山那边",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20rural%20family%20drama%20scene%20of%20misty%20mountains%20and%20a%20small%20village%20at%20dawn%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-06&orientation=portrait",
    backdrop: "",
    year: 2025,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.7,
    duration: "110分钟",
    episodeCount: 0,
    director: "郝念",
    cast: ["张大山", "刘小满", "李桂芬"],
    releaseDate: "2025-11-08",
    summary: "老教师守着一座山村小学四十年，最后一个学生离开时，他决定翻过山去。",
    synopsis:
      "滇西的山村里只剩一座小学和一位老教师。当最后一个学生也随父母搬去城里，他背起旧书包，第一次翻过那座挡住他大半辈子的山。山那边是陌生的城市与喧闹，他要用自己的方式，把四十年的课继续讲下去。",
    hot: 84,
  },
  {
    id: "m-007",
    type: "movie",
    title: "时间褶皱",
    poster:
      "https://readdy.ai/api/search-image?query=surreal%20time%20travel%20concept%20with%20a%20fractured%20clock%20and%20glowing%20corridors%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-07&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "英国",
    genres: ["科幻", "悬疑"],
    rating: 8.5,
    duration: "127分钟",
    episodeCount: 0,
    director: "Olivia Hart",
    cast: ["James Fox", "Amy Lin", "Ruth Vale"],
    releaseDate: "2026-08-02",
    summary: "物理学家发现时间存在褶皱，每一次回到过去都会让世界更接近崩塌。",
    synopsis:
      "物理学家 Amy 在实验中发现，时间并非直线，而是一张可以被折叠的纸。为了挽救一场意外，她第一次折返过去，却发现每修正一个错误，现实就多出一道裂缝。当世界开始遗忘她的名字，她必须做出最后的选择：留住所爱的人，还是留住整个宇宙。",
    hot: 92,
  },
  {
    id: "m-008",
    type: "movie",
    title: "雪岭孤旅",
    poster:
      "https://readdy.ai/api/search-image?query=frozen%20snowy%20mountain%20expedition%20scene%20with%20a%20solitary%20traveler%20in%20blue%20ice%20cave%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-08&orientation=portrait",
    backdrop: "",
    year: 2025,
    region: "挪威",
    genres: ["冒险", "剧情"],
    rating: 8.0,
    duration: "119分钟",
    episodeCount: 0,
    director: "Lars Berg",
    cast: ["Ingrid Sol", "Mads Holm"],
    releaseDate: "2025-10-16",
    summary: "为完成母亲的遗愿，一名登山者独自穿越北极圈内的冰原。",
    synopsis:
      "母亲去世前留下地图和一封未写完的信，要求女儿 Ingrid 替她走完未竟的路线。Ingrid 独自进入北极圈冰原，面对暴风雪、冰裂缝与孤独。当她在冰洞深处找到母亲当年的营地痕迹，也终于读懂了那封信的结尾。",
    hot: 78,
  },
  {
    id: "m-009",
    type: "movie",
    title: "重返黎明",
    poster:
      "https://readdy.ai/api/search-image?query=post%20apocalyptic%20city%20at%20dawn%20with%20a%20hero%20silhouette%20against%20glowing%20sky%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-09&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "美国",
    genres: ["科幻", "动作"],
    rating: 8.2,
    duration: "141分钟",
    episodeCount: 0,
    director: "Marcus Vale",
    cast: ["Ryan Cole", "Zoe Hart", "Liam Ross"],
    releaseDate: "2026-04-10",
    summary: "末日之后的第十年，一队幸存者踏上寻找传说中“黎明之城”的旅程。",
    synopsis:
      "大崩塌后的第十年，城市沦为废墟。幸存者 Ryan 在一台旧收音机里听到“黎明之城”的坐标。他带着妹妹和几位同伴穿越感染者与掠夺者的领地，去寻找最后一片净土。当黎明真正到来时，他们要面对的不是怪物，而是自己。",
    hot: 89,
  },
  {
    id: "m-010",
    type: "movie",
    title: "沙海孤影",
    poster:
      "https://readdy.ai/api/search-image?query=epic%20desert%20dune%20landscape%20with%20a%20small%20caravan%20silhouette%20under%20vast%20sky%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-10&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "中国大陆",
    genres: ["剧情", "冒险"],
    rating: 8.3,
    duration: "152分钟",
    episodeCount: 0,
    director: "邹岩",
    cast: ["陆骁", "白宛", "孙戈"],
    releaseDate: "2026-09-12",
    summary: "一支考古队深入塔克拉玛干，寻找被风沙掩埋千年的古城。",
    synopsis:
      "考古队长陆骁坚信沙漠深处藏着一座被史书抹去的古城。他带着小队与一位神秘向导进入塔克拉玛干腹地。风沙吞没脚印，绿洲一夜消失，而古城出土的文书揭示了一段被王朝刻意遗忘的历史。",
    hot: 86,
  },
  {
    id: "m-011",
    type: "movie",
    title: "晚安，旧时光",
    poster:
      "https://readdy.ai/api/search-image?query=gentle%20romantic%20nostalgic%20scene%20of%20two%20silhouettes%20on%20a%20quiet%20old%20town%20at%20dusk%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-11&orientation=portrait",
    backdrop: "",
    year: 2025,
    region: "中国台湾",
    genres: ["爱情", "剧情"],
    rating: 7.8,
    duration: "105分钟",
    episodeCount: 0,
    director: "林绥",
    cast: ["陳知", "許安安"],
    releaseDate: "2025-09-25",
    summary: "一封迟到了十五年的告白信，让两个青梅竹马在小镇重逢。",
    synopsis:
      "旧书店整理库存时，店主陈知翻出一封从未寄出的信。收信人是十五年前搬离小镇的许安安。当她因故回到老镇，两人在熟悉又陌生的街巷里，重新面对当年没能说出口的那些话。",
    hot: 75,
  },
  {
    id: "m-012",
    type: "movie",
    title: "铁血苍穹",
    poster:
      "https://readdy.ai/api/search-image?query=dramatic%20war%20epic%20scene%20of%20soldiers%20silhouette%20against%20smoke%20and%20orange%20firelight%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-movie-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=dramatic%20war%20battlefield%20smoke%20scene%20with%20warm%20orange%20fire%20glow%20against%20dark%20sky%2C%20cinematic%20epic%2C%20no%20text%2C%20highly%20detailed&width=1600&height=900&seq=mogu-bd-02&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["战争", "剧情"],
    rating: 8.8,
    duration: "149分钟",
    episodeCount: 0,
    director: "沈毅",
    cast: ["何铮", "关山", "叶澜"],
    releaseDate: "2026-08-15",
    summary: "一群年轻的飞行员，用最简陋的装备守护祖国的天空。",
    synopsis:
      "上世纪四十年代，一支年轻的飞行队在装备匮乏的条件下担负起防空重任。队长何铮带着一群平均年龄不到二十三岁的飞行员，在一次次升空中见证牺牲与成长。苍穹之下，他们用生命写下属于自己的航迹。",
    hot: 91,
  },
  {
    id: "t-001",
    type: "tv",
    title: "暗涌之城",
    poster:
      "https://readdy.ai/api/search-image?query=dark%20urban%20crime%20thriller%20scene%20of%20rainy%20city%20skyline%20at%20night%20with%20a%20lone%20figure%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=moody%20rainy%20city%20skyline%20at%20night%20with%20deep%20blue%20tones%20and%20neon%20reflections%2C%20cinematic%2C%20no%20text%2C%20highly%20detailed&width=1600&height=900&seq=mogu-bd-03&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.9,
    duration: "45分钟/集",
    episodeCount: 24,
    director: "冯歧",
    cast: ["江野", "苏眠", "祁川", "温雪"],
    releaseDate: "2026-06-12",
    summary: "一座被资本暗流裹挟的城市，一名记者与一名警察联手揭开层层黑幕。",
    synopsis:
      "调查记者苏眠追查一桩看似普通的坠楼案，却意外触碰到一张覆盖整座城市的地下网络。刑警队长江野成为她唯一的盟友。两人在明暗之间步步紧逼，每揭开一层真相，就要付出更大的代价。暗涌之下，没有人是干净的。",
    hot: 97,
  },
  {
    id: "t-002",
    type: "tv",
    title: "鹿鸣山庄",
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20mansion%20mystery%20scene%20with%20moonlight%20and%20wooden%20corridors%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-02&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "中国大陆",
    genres: ["古装", "悬疑"],
    rating: 8.5,
    duration: "42分钟/集",
    episodeCount: 30,
    director: "顾闻",
    cast: ["裴清", "祝晚", "陆叙"],
    releaseDate: "2026-05-08",
    summary: "山庄一夜之间死了三个人，而所有人都有不在场证明。",
    synopsis:
      "鹿鸣山庄的赏花宴上，三位宾客在同一夜相继死去。刚入仕的女官祝晚奉命查案，却发现每个人都在说谎。随着调查深入，一桩尘封十年的旧怨浮出水面，而真凶，就藏在那些看似无辜的面孔里。",
    hot: 90,
  },
  {
    id: "t-003",
    type: "tv",
    title: "都市夜归人",
    poster:
      "https://readdy.ai/api/search-image?query=modern%20city%20night%20life%20scene%20with%20warm%20street%20lamps%20and%20walking%20figures%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-03&orientation=portrait",
    backdrop: "",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "情感"],
    rating: 8.2,
    duration: "40分钟/集",
    episodeCount: 36,
    director: "余南",
    cast: ["周絮", "陈屿", "林砚"],
    releaseDate: "2025-11-20",
    summary: "深夜便利店里的六个陌生人，拼出一座城市的孤独与温柔。",
    synopsis:
      "一家 24 小时便利店，是这座城市深夜的落脚点。外卖员、考研女孩、出租车司机、刚分手的白领……六个在夜里醒着的人，在这里相遇。他们交换泡面、故事与沉默，也慢慢拼凑出各自生活的出口。",
    hot: 85,
  },
  {
    id: "t-004",
    type: "tv",
    title: "悬河",
    poster:
      "https://readdy.ai/api/search-image?query=crime%20investigation%20scene%20with%20dark%20river%20and%20police%20car%20lights%20at%20night%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-04&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "中国大陆",
    genres: ["刑侦", "悬疑"],
    rating: 8.7,
    duration: "45分钟/集",
    episodeCount: 20,
    director: "邢远",
    cast: ["祁川", "苏眠", "方岸"],
    releaseDate: "2026-07-01",
    summary: "河底浮出的旧案卷宗，牵出跨越十二年的七宗悬案。",
    synopsis:
      "一场洪水冲开河口淤积，冲出一只密封铁箱，里面是十二年前一起悬案的完整卷宗。刑侦队长方岸发现，这并非孤例，而是七宗悬案共享的一把钥匙。河水向东，真相逆行，他必须在自己被卷入之前，把谜底打捞上岸。",
    hot: 93,
  },
  {
    id: "t-005",
    type: "tv",
    title: "我们的十年",
    poster:
      "https://readdy.ai/api/search-image?query=youth%20coming%20of%20age%20scene%20of%20graduates%20on%20a%20campus%20field%20at%20golden%20hour%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-05&orientation=portrait",
    backdrop: "",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "情感"],
    rating: 8.0,
    duration: "38分钟/集",
    episodeCount: 40,
    director: "黎野",
    cast: ["沈麓", "赵一诺", "何斯"],
    releaseDate: "2025-10-02",
    summary: "五个大学同窗，用十年时间验证友情、理想与现实的距离。",
    synopsis:
      "2016 年的夏天，五个少年在毕业照里笑得灿烂。十年后，有人留在原地，有人远走他乡，有人弄丢了自己。这部剧用十年时间轴，记录他们各自的挣扎、重逢与和解，也记录一代人共同走过的青春。",
    hot: 80,
  },
  {
    id: "t-006",
    type: "tv",
    title: "群星闪耀时",
    poster:
      "https://readdy.ai/api/search-image?query=futuristic%20space%20station%20interior%20with%20a%20starry%20window%20and%20an%20astronaut%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-06&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "美国",
    genres: ["科幻", "悬疑"],
    rating: 8.6,
    duration: "50分钟/集",
    episodeCount: 10,
    director: "Alan Frost",
    cast: ["Nora King", "Eric Shaw", "Tess Lin"],
    releaseDate: "2026-03-20",
    summary: "空间站收到一段来自三百年前的信号，而发出者正是站内的成员之一。",
    synopsis:
      "位于地月拉格朗日点的“群星”空间站收到一段无法解释的加密信号，经解码后，发出者竟是站内一位工程师的祖父。时间、血缘与宇宙在此交汇，站员们必须在信号被截获前，弄明白自己究竟身处哪一段历史。",
    hot: 88,
  },
  {
    id: "t-007",
    type: "tv",
    title: "归途列车",
    poster:
      "https://readdy.ai/api/search-image?query=emotional%20scene%20of%20a%20train%20crossing%20countryside%20at%20dusk%20with%20warm%20light%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-07&orientation=portrait",
    backdrop: "",
    year: 2025,
    region: "韩国",
    genres: ["剧情", "情感"],
    rating: 8.3,
    duration: "60分钟/集",
    episodeCount: 16,
    director: "박준서",
    cast: ["이서진", "김도연", "한지원"],
    releaseDate: "2025-12-05",
    summary: "一列开往故乡的夜班车，载着八个各自背负故事的人。",
    synopsis:
      "除夕夜的最后一班列车开往海边小城。车厢里有辞职返乡的青年、抱着骨灰盒的老妇人、逃婚的新娘、多年未见的老友。列车在夜色里穿行，每一站都有人下车，也都有人终于说出藏在心里的话。",
    hot: 82,
  },
  {
    id: "t-008",
    type: "tv",
    title: "破晓行动",
    poster:
      "https://readdy.ai/api/search-image?query=spy%20thriller%20scene%20with%20a%20figure%20in%20trench%20coat%20on%20an%20old%20city%20street%20at%20dawn%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-08&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "中国大陆",
    genres: ["谍战", "悬疑"],
    rating: 8.4,
    duration: "44分钟/集",
    episodeCount: 32,
    director: "霍岩",
    cast: ["谢衍", "林书", "沈亦"],
    releaseDate: "2026-04-18",
    summary: "代号“破晓”的潜伏任务，从一封假电报开始。",
    synopsis:
      "1943 年，一份被截获的电报让地下工作者谢衍被迫提前启动“破晓”计划。他要在敌人的眼皮底下送出关键情报，而最危险的，是那个知道他真实身份、却始终保持沉默的人。",
    hot: 87,
  },
  {
    id: "t-009",
    type: "tv",
    title: "春山可望",
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20romance%20scene%20with%20blossom%20trees%20and%20an%20elegant%20figure%20in%20hanfu%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-09&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "中国大陆",
    genres: ["古装", "情感"],
    rating: 8.1,
    duration: "42分钟/集",
    episodeCount: 28,
    director: "苏云舒",
    cast: ["温雪", "裴清", "顾昭"],
    releaseDate: "2026-02-14",
    summary: "医女与落魄世子的相遇，从一场瘟疫里的相救开始。",
    synopsis:
      "南朝末年，瘟疫横行。医女春山在乱世中救治百姓，意外救下被诬陷谋反的世子顾昭。两人从互相试探到并肩同行，在权谋与病疫之间，守护一方安宁，也守护彼此心里那点未说破的光。",
    hot: 84,
  },
  {
    id: "t-010",
    type: "tv",
    title: "大宋提刑录",
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20detective%20scene%20with%20a%20scholar%20official%20in%20a%20lantern%20lit%20hall%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20rooftops%20at%20dusk%20with%20lantern%20lights%20and%20misty%20mountains%2C%20cinematic%2C%20no%20text%2C%20highly%20detailed&width=1600&height=900&seq=mogu-bd-04&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["古装", "悬疑"],
    rating: 8.8,
    duration: "45分钟/集",
    episodeCount: 34,
    director: "顾闻",
    cast: ["陆叙", "祝晚", "裴清"],
    releaseDate: "2026-08-08",
    summary: "一桩无尸命案，让年轻的提刑官卷入朝堂与江湖的双重迷局。",
    synopsis:
      "大宋年间，年轻的提刑官陆叙走马上任，接手的第一个案子便是“无尸命案”。他凭借验尸之能抽丝剥茧，却发现每一条线索都通向朝堂之上。江湖恩怨与官场倾轧交织，而他手中的那本《提刑录》，正一页页写满真相。",
    hot: 92,
  },
  {
    id: "t-011",
    type: "tv",
    title: "密室之声",
    poster:
      "https://readdy.ai/api/search-image?query=eerie%20british%20mansion%20mystery%20with%20a%20single%20lit%20window%20in%20fog%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-11&orientation=portrait",
    backdrop: "",
    year: 2025,
    region: "英国",
    genres: ["悬疑", "惊悚"],
    rating: 8.2,
    duration: "55分钟/集",
    episodeCount: 8,
    director: "Harold Gray",
    cast: ["Emma Blake", "Tom Reed"],
    releaseDate: "2025-09-30",
    summary: "六个人被困在没有出口的庄园，只有声音告诉他们该相信谁。",
    synopsis:
      "六位互不相识的人受邀来到一座古老庄园，却发现所有门窗都被封死。一个神秘声音通过广播给出规则：每晚必须指认一人离开。恐惧撕开伪装，每个人都藏着不可告人的秘密，而真正的出口，藏在他们最不愿面对的记忆里。",
    hot: 79,
  },
  {
    id: "t-012",
    type: "tv",
    title: "山河谣",
    poster:
      "https://readdy.ai/api/search-image?query=nostalgic%20chinese%20countryside%20period%20scene%20with%20terraced%20fields%20and%20a%20village%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20simple%20clean%20gradient%20background%2C%20no%20text%2C%20highly%20detailed&width=500&height=750&seq=mogu-tv-12&orientation=portrait",
    backdrop: "",
    year: 2026,
    region: "中国大陆",
    genres: ["年代", "剧情"],
    rating: 8.5,
    duration: "45分钟/集",
    episodeCount: 38,
    director: "郝念",
    cast: ["张大山", "刘小满", "叶澜", "关山"],
    releaseDate: "2026-01-20",
    summary: "一条河谷，三代人的迁徙与守望。",
    synopsis:
      "从上世纪五十年代到今天，河谷边的小村经历了开荒、搬迁、外出务工与返乡创业。三代人在同一片土地上做出不同选择，有人离开，有人归来。山河依旧，而谣歌不停，唱的是普通人被时代推着往前走的一生。",
    hot: 86,
  },
];

export const featuredIds = ["m-001", "t-001", "m-012", "t-010"];